module.exports = __webpack_public_path__ + "img/6.b37a99e0.png";